import React from "react";

const POPULATE_POLLS_DATA = 'locale/polls/POPULATE_POLLS_DATA';
const SET_SEARCH_TEXT = "locale/polls/SET_SEARCH_TEXT";
const SET_BLOCK_FILTER_OPTIONS = "locale/polls/SET_BLOCK_FILTER_OPTION";
const SET_UNIT_FILTER_OPTIONS = "locale/polls/SET_UNIT_FILTER_OPTION";
const SET_USER_GROUP_FILTER_OPTIONS = "locale/polls/SET_USER_GROUP_FILTER_OPTION";

export const initialState = {
    logFilterText: '',
    blockFilterOptions: [],
    unitFilterOptions: [],
    userGroupFilterOptions: [],
};

export const pollsReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_SEARCH_TEXT: {
            return {
                ...state,
                logFilterText: action.value
            }
        }

        case SET_BLOCK_FILTER_OPTIONS: {
            return {
                ...state,
                polls: {
                    ...state.polls,
                    blockFilterOptions: action.value
                }
            }
        }

        case SET_UNIT_FILTER_OPTIONS: {
            return {
                ...state,
                polls: {
                    ...state.polls,
                    unitFilterOptions: action.value
                }
            }
        }

        case SET_USER_GROUP_FILTER_OPTIONS: {
            return {
                ...state,
                polls: {
                    ...state.polls,
                    userGroupFilterOptions: action.value
                }
            }
        }

    }
    return state;
}

export const setSearchText = (value) => ({
    type: SET_SEARCH_TEXT,
    value
})

export const setBlockFilterOptions = (value) => ({
    type: SET_BLOCK_FILTER_OPTIONS,
    value
})

export const setUnitFilterOptions = (value) => ({
    type: SET_UNIT_FILTER_OPTIONS,
    value
})

export const setUserGroupFilterOptions = (value) => ({
    type: SET_USER_GROUP_FILTER_OPTIONS,
    value
})


